@switch (columnName) {
  @case ('name') {
    {{ form.firstName.value + ' ' + form.lastName.value }}
  }
  @case ('number') {
    {{ form.prefix.value + ' ' + form.phoneNumber.value }}
  }
  @case ('edit') {
    @if (!hideButtons) {
      <button mat-button (click)="buttonFunctions.edit()">
        <mat-icon>edit</mat-icon>
      </button>
    }
  }
  @case ('delete') {
    @if (!hideButtons) {
      <button mat-button (click)="buttonFunctions.delete()">
        <mat-icon>delete</mat-icon>
      </button>
    }
  }
  @default {
    {{ form.get(columnName)?.value }}
  }
}
